import {
  Box,
  Button,
  LinearProgress,
  Paper,
  TextField,
  styled,
} from '@mui/material';

export const Content = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}));

export const Header = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '24px',
  flexWrap: 'wrap',
}));

export const SummaryGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  gap: '16px',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const SummaryCard = styled(Paper)(() => ({
  border: '1px solid #E4E4E7',
  borderRadius: '12px',
  boxShadow: 'none',
  padding: '20px',
}));

export const TableCard = styled(Paper)(() => ({
  border: '1px solid #E4E4E7',
  borderRadius: '12px',
  boxShadow: 'none',
  overflow: 'hidden',
}));

export const CapacityProgress = styled(LinearProgress)(() => ({
  width: '120px',
  height: '8px',
  borderRadius: '8px',
  backgroundColor: '#EEEFF2',
}));

export const LimitInput = styled(TextField)(() => ({
  width: '170px',
  '& input': {
    fontWeight: 600,
  },
}));

export const Actions = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '12px',
  flexWrap: 'wrap',
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  minWidth: '190px',
  height: '48px',
  borderRadius: '24px',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
  },
}));
